import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './model/store';
import { BrowserRouter } from 'react-router-dom';
import { Router } from './Router';
import './main.css';
import './styles/globals.css';
import { addLogSender, isRunningUnitTest } from '@shared';
import { clientLogSender } from './util';
import { logRocketInit } from '@shared';
import ScrollToTop from './components/ScrollToTop';
import { IntercomUpdate } from './components';
import { Toaster } from './components/ui/toaster';
import { ConfigurableAuth0Provider } from './components/ConfigurableAuth0Provider';
import { OnboardingTimeTracker } from './components/OnboardingTimeTracker';
import { AppOpenTracker } from './components/AppOpenTracker';

logRocketInit();
addLogSender(clientLogSender);

if (!isRunningUnitTest()) {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <ConfigurableAuth0Provider>
            <ScrollToTop />
            <IntercomUpdate />
            <AppOpenTracker />
            <Router />
            <OnboardingTimeTracker />
          </ConfigurableAuth0Provider>
        </BrowserRouter>
      </Provider>
      <Toaster />
    </React.StrictMode>,
  );
}
